import Vue from 'vue'
import Router from 'vue-router'
import _import from './_import_development'
import  { menuPage } from  '@/commonJs/commonconf'

/**
 * 子路由配置
 */
import  bd from './bd'
import  sys from './sys'
import  ht from './ht'
import  pay from './pay'
import  pro from './pro'
import  report from './report'
import  supplier from './supplier'

Vue.use(Router);

//异步按需要加载界面

//静态路由 不需要做权限验证的
export const constantRouterMap =[
  {
    path: '/',
    name: 'login',
    component: _import("login"),
  },
  {
    path: '/zhuce',
    name: '注册',
    component: _import("zhuce"),
  },
  {
    path: '/loginByMobile',
    name: '手机验证码登录',
    component: _import("loginByMobile"),
  },
  {
    path: '/mima',
    name: '找回密码',
    component: _import("mima"),
  },
  {
    path: '/login',
    name: 'login',
    component: _import("login"),
  },
  {
    path: '/ssoLogin',
    name: 'ssoLogin',
    component: _import("ssoLogin"),
  },
  {
    path: '/2',
    name: '2',
    component: _import("Home"),
    children: [
      { path: '/2', component: _import("2"), name: '桌面2' },
    ]
  },

  {
    path: '/401',
    name: '401',
    component: _import("errorPage/401"),
  }
]

let  deskRoute= {
  path: '/desk',
  name: 'desk',
  component: _import("Home"),
  children: [
    {path: '/desk', component: null, name: '桌面'},
  ]
}

export const  getDeskRoute = function() {
  if (menuPage.loginUser) {
    switch (menuPage.loginUser.module) {
      case "customer" :
        deskRoute.children[0].component = _import("cdesk");
        ;
        break;
      case "company" :
        deskRoute.children[0].component = _import("mydesk");
        ;
        break;
    }
  }
  return deskRoute;
}

//动态路由需要做权限验证后映射
export  const asyncRouterMap=[
  bd,
  sys,
  ht,
  pay,
  pro,
  report,
  supplier,
]

  /**
 * 主路由配置
 */
let router =  new Router({
    mode: "history",
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return {
          x: 0,
          y: 0
        }
      }
    },
    routes: constantRouterMap
  });
export  default router;



// WEBPACK FOOTER //
// ./src/router/index.js